<template>
    <!--검사 상태-->
    <div class="box-container">

        <div class="box-container-header">
            <h3 class="box-title" :key="locale">
                {{ $t('LABEL.EVAL_STAT')}}<!--검사 상태-->

                <select-box-single
                    select-id="select_cmpl_result_state_type"
                    select-class="type-inline size-s"
                    :select-box-options="typeOptions"
                    :select-box-value="chartType"
                    :use-translate="true"
                    @onSelectChange="changeChartType($event.value)"></select-box-single>

                <button type="button" class="buttons-icon" data-type="ghost" data-size="xs" data-icon="info" data-tooltip-content="#tooltip-compliance-status" data-trigger="tooltip">info</button>

                <!-- 검사 상태 툴팁 -->
                <div class="tooltip_templates">
                    <div id="tooltip-compliance-status">
                        {{$t('DASHBOARD.STATE.TOOLTIP_1')}}<br>
                        {{$t('DASHBOARD.STATE.TOOLTIP_2')}}
                    </div>
                </div>
            </h3>

            <div class="actions">
                <div class="segmented-control"><!--select box -->
                    <input type="radio" id="sc02" name="sc" :checked="activeFailStat === 'F' ? true : null" @click="changeActive('F')">
                    <label for="sc02" >{{ $t('DASHBOARD.SUMMARY.TAB.FAIL')}}<!--실패한 규칙--></label>

                    <input type="radio" id="sc01" name="sc" :checked="activeFailStat === 'P' ? true : null" @click="changeActive('P')">
                    <label for="sc01">{{ $t('DASHBOARD.SUMMARY.TAB.PASS')}}<!--성공한 규칙--></label>

                    <input type="radio" id="sc03" name="sc" :checked="activeFailStat === 'E' ? true : null" @click="changeActive('E')">
                    <label for="sc03" >{{ $t('DASHBOARD.SUMMARY.TAB.ERROR')}}<!--실패한 규칙--></label>
                </div>
            </div>
        </div>

        <nav class="navigation-tab" data-size="s">
            <button type="button" class="tab-item"
                    :name=VENDOR.AWS
                    :class="[VENDOR.AWS===selectedVendor ? 'selected' : '' ]"
                    v-if="!disableAWS"
                    @click="changeVendor"
            >{{ $t('TYPE.AWS')}}</button>
            <button type="button" class="tab-item"
                    :name=VENDOR.AZURE
                    :class="[VENDOR.AZURE===selectedVendor ? 'selected' : '' ]"
                    v-if="!disableAZURE"
                    @click="changeVendor"
            >{{ $t('TYPE.AZURE')}}</button>
            <button type="button" class="tab-item"
                    :name=VENDOR.GCP
                    :class="[VENDOR.GCP===selectedVendor ? 'selected' : '' ]"
                    v-if="!disableGCP"
                    @click="changeVendor"
            >{{ $t('TYPE.GCP')}}</button>
        </nav>
        <PieChart
            :locale="locale"
            :chartData="filterDataByVendor"
            :activeFailStat="activeFailStat"
            :chartType="chartType"
            :pending="pending"
        />
    </div>
</template>

<script>
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";
    import Report from '../../dashboard/reports/cspReport.vue';
    import PieChart from '../../dashboard/reports/PieChart.vue';
    import _ from "lodash";
    export default {
        name: 'TabResultState',
        props: {
            cmplId: String,
            activeFail: String,
            ruleIdentify: Array,
            locale: String,
            curCmpnId: String,
            failedRulesList: Array,
            pending: Boolean,
        },
        components: {
            Report, PieChart
        },
        data: function() {
            return {
                chartType: "prodList", // prodList, ctgList 로 나뉨. prodList 가 기본 값
                activeFailStat: 'F',
                orderBy: 'failedcount',
                ruleRawList: [],
                azureRawList: [],
                awsRawList: [],
                gcpRawList: [],
                awsChartDataShow:[], // chart에 담을 배열
                azureChartDataShow: [],
                gcpChartDataShow: [],
                colorSet: [], // chart color list
                typeOptions: this.constants.CHART_TYPE_OPTIONS,
                VENDOR: this.constants.VENDOR,
                selectedVendor: this.constants.VENDOR.AWS,
                chartData: [],
                disableAWS: true,
                disableAZURE: true,
                disableGCP: true,
                filterDataByVendor: []
            }
        },
        mounted: function() {
            this.activeFailStat = this.activeFail;
        },
        watch: {
            failedRulesList(ruleList, olval) {
                this.disableAZURE = true;
                this.disableAWS = true;
                this.disableGCP = true;
                if (ruleList) {
                    ruleList.forEach((rule) => {
                        if (rule.vendors === 'GCP') {
                            this.selectedVendor = this.VENDOR.GCP;
                            this.disableGCP = false;
                        }
                        if (rule.vendors === 'AZU') {
                            this.selectedVendor = this.VENDOR.AZURE;
                            this.disableAZURE = false;
                        }
                        if (rule.vendors === 'AWS') {
                            this.selectedVendor = this.VENDOR.AWS;
                            this.disableAWS = false;
                        }
                    });
                }
                this.getDataByVendor();
            },
            locale() {
                this.getDataByVendor();
            }
        },
        methods: {
            getDataByVendor() {
                let dataByVendor = [];
                let data = this.failedRulesList;
                if (data) {
                    if (this.selectedVendor === this.VENDOR.AWS) {
                        dataByVendor = data.filter(function (rule) {
                            return rule.vendors === "AWS"
                        });
                    } else if (this.selectedVendor === this.VENDOR.AZURE) {
                        dataByVendor = data.filter(function (rule) {
                            return rule.vendors === "AZU"
                        });
                    } else if (this.selectedVendor === this.VENDOR.GCP) {
                        dataByVendor = data.filter(function (rule) {
                            return rule.vendors === "GCP"
                        });
                    }
                }
                this.filterDataByVendor = dataByVendor;
            },
            changeVendor(e) {
                this.selectedVendor = e.target.name;
                this.getDataByVendor();
            },
            // 프로덕트 / 카테고리 변경
            changeChartType(type) {
                this.chartType = type;
                this.getDataByVendor()
            },
            // 실패한 규칙, 패스한 규칙 active 변경
            changeActive(active) {
                this.activeFailStat = active;
            }
        }


    }
</script>
<style scoped>
@import '../../../../static/styles/gv_amchart.css';
.amcharts-Rectangle-group{fill:red !important;}
.mockup-chart img {
    margin-top: 35px;
    margin-left: -22px;
}
</style>



// WEBPACK FOOTER //
// src/components/compliance/widget/TabResultState.vue